var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLawyerPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#57595a",
    d: "M14.716 11.27c-.98 0-1.942-.153-2.853-.455-.447-.152-.996-.012-1.268.268l-1.8 1.358c-2.085-1.114-3.37-2.398-4.47-4.47L5.645 6.22c.342-.342.465-.842.318-1.31a9.103 9.103 0 0 1-.456-2.858c0-.708-.576-1.284-1.284-1.284H1.283C.576.768 0 1.344 0 2.05 0 10.166 6.6 16.768 14.716 16.768c.708 0 1.284-.576 1.284-1.284v-2.93c0-.708-.576-1.284-1.284-1.284z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLawyerPhone);
export default __webpack_public_path__ + "static/media/icon-lawyer-phone.c2cbfe58.svg";
export { ForwardRef as ReactComponent };